import { getAgentUrl } from "src/util/url";

const EVENT_TYPE = {
  ON_MESSAGE_CHUNK: "message_chunk",
  ON_MESSAGE: "message",
  ON_CURRENT_TOOL_USE: "current_tool_use",
  GENERIC_EVENT: "event",
  STREAM_COMPLETE: "stream_complete",
};

const streamAIResponse = async (
  params,
  {
    tenantId, // eslint-disable-line no-unused-vars
    apiUrl,
    onMessageStart,
    onMessage,
    onMessageChunk,
    onCurrentToolUse,
    onError,
    onDone,
    headers = {},
    agentName,
    signal,
  }
) => {
  try {
    const response = await fetch(getAgentUrl({ tenantId, apiUrl, agentName }), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: headers?.Authorization,
        "x-workspace-id": headers?.["x-workspace-id"],
      },
      body: JSON.stringify({
        ...params,
        headers,
        stream: true,
      }),
      signal,
    });

    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let buffer = "";

    let complete = false;

    // eslint-disable-next-line no-constant-condition
    while (!complete) {
      const { done, value } = await reader.read();

      buffer += decoder.decode(value, { stream: true });
      const lines = buffer.split("\n");
      buffer = lines.pop() || "";

      for (const line of lines) {
        if (line.startsWith("data: ")) {
          const data = JSON.parse(line.replace("data: ", ""));

          if (data?.error) {
            onError(data);
            complete = true;
          }

          if (
            data?.type === EVENT_TYPE.GENERIC_EVENT &&
            data?.event?.messageStart?.role === "assistant"
          ) {
            onMessageStart?.(data);
          }

          if (data?.type === EVENT_TYPE.ON_MESSAGE_CHUNK) {
            onMessageChunk?.(data);
          } else if (data?.type === EVENT_TYPE.ON_MESSAGE) {
            onMessage?.(data);
          } else if (data?.type === EVENT_TYPE.ON_CURRENT_TOOL_USE) {
            onCurrentToolUse?.(data);
          } else if (data?.type === EVENT_TYPE.STREAM_COMPLETE) {
            onDone();
            complete = true;
          }
        }
      }

      if (done && !complete) {
        onError("Stream ended early.");
        complete = true;
      }
    }
  } catch (e) {
    if (signal?.aborted) {
      return;
    }
    onError(e);
  }
};

export default streamAIResponse;
